module.exports = "/dashboard/_next/static/images/404-8ed2a81700dd062c68106c04d39cade5.png";